import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import Pagin, { PaginationType } from 'src/components/common/Pagin';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import Rows from './Rows';
import { getDetailPagin } from 'src/common/helper';

const PatientIcons = () => {
  const [data, setData] = useState<any>([]);
  const [pagination, setPagination] = useState<PaginationType>();

  const getSetting = async (page: number) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      postAPI(`/master/patienticon-search?token=${token}`, {
        page: page,
        pagesize: 10,
      })
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setData(res.data.items);
            setPagination(res.data.pagination);
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  useEffect(() => {
    getSetting(1);
  }, []);

  const handlePageChange = (eventL: any, value: number) => {
    getSetting(value);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell width={'100px'}>アイコン</TableCell>
              <TableCell width={'200px'}>色</TableCell>
              <TableCell width={'200px'}>ステータス</TableCell>
              <TableCell>備考</TableCell>
              <TableCell align='center'>修正</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 &&
              data.map((item: any, index: number) => (
                <Rows item={item} key={index} />
              ))}
            {data.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={5}
                  sx={{ textAlign: 'center', verticalAlign: 'center' }}
                >
                  データがありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {data.length > 0 && pagination && (
        <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
          <Typography
            component='label'
            sx={{
              color: '#AAB2BD',
              fontWeight: '400',
              fontSize: '10px',
              lineHeight: '12px',
            }}
          >
            {getDetailPagin(pagination)}
          </Typography>
        </Box>
      )}
      {data.length > 0 && pagination && pagination.page && (
        <Pagin handlePageChange={handlePageChange} pagination={pagination} />
      )}
    </>
  );
};

export default PatientIcons;
